"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultDatetimeInputControl = exports.defaultDatetimeInputControlValueFormatter = void 0;
const react_1 = __importDefault(require("react"));
const DefaultDatetimeInputControl_1 = require("./DefaultDatetimeInputControl");
const constants_1 = require("../helpers/constants");
const formatValue_1 = require("../helpers/formatValue");
const defaultDatetimeInputControlValueFormatter = ({ value, withTime, withSeconds = false, is12Hours, texts }) => {
    const uiTexts = Object.assign({ am: constants_1.DEFAULT_TEXTS.am, pm: constants_1.DEFAULT_TEXTS.pm }, texts);
    return value ? (0, formatValue_1.formatValue)(value, withTime, withSeconds, is12Hours, uiTexts) : '';
};
exports.defaultDatetimeInputControlValueFormatter = defaultDatetimeInputControlValueFormatter;
function createDefaultDatetimeInputControl({ valueFormatter, hasKeyboardEnter = true } = {}) {
    return function defaultDatetimeInputControlRenderer(props) {
        return (react_1.default.createElement(DefaultDatetimeInputControl_1.DefaultDatetimeInputControl, Object.assign({}, props, { valueFormatter: valueFormatter, hasKeyboardEnter: hasKeyboardEnter })));
    };
}
exports.createDefaultDatetimeInputControl = createDefaultDatetimeInputControl;
//# sourceMappingURL=defaultDatetimeInputControlRenderer.js.map